import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 25 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.312 25V12.498h3.698l.49-4.308h-4.188l.006-2.156c0-1.123.115-1.725 1.844-1.725h2.312V0h-3.699C10.333 0 8.77 2.09 8.77 5.604v2.587H6v4.308h2.77V25z"
    }, null, -1)
  ]))]))
}
export default { render: render }